import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Typography,
  Tabs,
  Tab,
  CircularProgress,
  
} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import AreasOfWorkSection from "../../sections/AreasOfWorkSection";
import { toast } from "react-toastify";
import useApi from "../../../api/useApi";
import { CategoryGet, SubCategoryDelete } from "../../../api/orgService";
import { useLocation, useNavigate } from "react-router";
import WhatWeDo from "../../pages/WhatWeDo";
import ConfirmDeleteDialog from "../Consumer/ConfirmDeleteDialog";

export default function SubCategoryAdmin({ onAddSubcategory }) {

  const subCATEGORY_FORM_STORAGE_KEY = "subcategoryFormState";
  const location = useLocation();
  const navigate = useNavigate()
  const [categories, setCategories] = useState([]);
  const [FileUpload, setConstFileUpload] = useState(false);

  const [openDelete, setOpenDelete] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [subcategory, setsubCategory] = useState({
    name: "",
    category: "",
    subcategory_alias: "",
    description: "",
    link: "",
    image_introduction: "",
    released: false,
  });

  const [tabPreviewCreate, setTabPreviewCreate] = useState(0); // 0 = New, 1 = Preview
  const [tabIndex, setTabIndex] = useState(0); // 0 = Link, 1 = Upload
  const fileInputRef = useRef(null);

  // create subcategory
  const {
    request: createSubCategory,
    data: createSubCategoryData,
    error: createSubCategoryError,
    clearHook
  } = useApi(onAddSubcategory);

  const {
      request: deleteSubCategory,
      data: deleteSubCategoryData,
      error: deleteSubCategoryError,
      loading: deleteSubCategoryLoading,
      clearHook:clearHookData
    } = useApi(SubCategoryDelete);

  useEffect(() => {
    if (createSubCategoryData?.status === 200) {
      toast.success(
        `${JSON.stringify(createSubCategoryData?.data, null, 2)}`,
        { position: "top-center" }
      );
      window.localStorage.removeItem(subCATEGORY_FORM_STORAGE_KEY);
      setsubCategory({
        name: "",
        subcategory_alias: "",
        category: "",
        description: "",
        link: "",
        image_introduction: "",
        released: false,
      });
      clearHook()
    navigate(-1,{state: {refresh:"subcategory"}})
    }
  }, [createSubCategoryData]);

  useEffect(() => {
    if (createSubCategoryError) {
      toast.error(
        `${JSON.stringify(createSubCategoryError?.response?.data, null, 2)}`,
        { position: "top-center" }
      );
    }
  }, [createSubCategoryError]);

  // get categories
  const {
    request: getAllCategories,
    data: categoryData,
    error: categoryError,
    loading: categoryLoading,
  } = useApi(CategoryGet);

  useEffect(() => {
    getAllCategories();
  }, []);

  useEffect(() => {
    if (categoryData?.status === 200) {
      setCategories(categoryData?.data?.results);
    }
  }, [categoryData]);

  useEffect(() => {
    if (location?.state?.refresh === "category") {
      getAllCategories();
    }
  }, [location?.state]);

  useEffect(() => {
    if (categoryError) {
      toast.error(`${JSON.stringify(categoryError?.response?.data, null, 2)}`, {
        position: "top-center",
      });
    }
  }, [categoryError]);

  useEffect(()=>{
      let subcategoryData2 = location?.state?.subcategory;
      if(subcategoryData2){
        //   console.log("cat: ",subcategoryData2)
          setTabPreviewCreate(0)
          setsubCategory({... subcategoryData2}) 
        //   setsubCategory((prev) => ({ ...prev, category: value }));
        handleCategoryChange({target:{name:"category",value: subcategoryData2?.category?.id}})
          // setCategory({
          //     name: categoryData2?.name,
          //     category_alias: categoryData2?.category_alias,
          //     description: categoryData2?.description,
          //     link:categoryData2?.link,
          //     image_introduction: categoryData2?.image_introduction,
          //     released: categoryData2?.released,
          //   });
        //   console.log("subcat: ",subcategory)
          }
  
    }, [location?.state?.subcategory])

  // helpers
  const generateAlias = () => {
    const name = subcategory?.name.trim();
    return name.toLowerCase().replace(/\s+/g, "-");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setsubCategory((prev) => ({ ...prev, [name]: value }));
    window.localStorage.setItem(
      subCATEGORY_FORM_STORAGE_KEY,
      JSON.stringify(subcategory)
    );
  };

  const handleCategoryChange = (e) => {
    const { name, value } = e.target;
    setsubCategory((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setsubCategory((prev) => ({ ...prev, value: previewUrl }));
      const formData = new FormData();
      formData.append("image", file);
      setConstFileUpload(true);
      try {
        const res = await fetch("https://fountainafrica.org/cms/ftp-files/", {
          method: "POST",
          body: formData,
        });
        if (res?.status === 201) {
          let result = await res.json();
          setsubCategory((prevData) => ({
            ...prevData,
            image_introduction: result?.path,
          }));
          setConstFileUpload(false);
        } else {
          setConstFileUpload(false);
        }
      } catch (error) {
        console.log(error);
        setConstFileUpload(false);
      }
    }
  };

  const handleSubmit = () => {
    if (!subcategory.name) return alert("Please provide a value.");
    createSubCategory(subcategory?.id,subcategory);
  };

  const handleDelete = async () => {
    if (!subcategory?.name) return alert("Please provide a name value.");
    deleteSubCategory(subcategory?.id);
  };

  const handleCancelAndBack = (e)=>{
    e.preventDefault()
    navigate(-1)
  }
  useEffect(() => {
    const saved = window.localStorage.getItem(subCATEGORY_FORM_STORAGE_KEY);
    if (saved) {
      try {
        const obj = JSON.parse(saved);
        // setsubCategory(obj);
      } catch (err) {
        console.error("Could not parse saved subcategory form state", err);
      }
    }
  }, []);

  useEffect(() => {
    if (subcategory?.name?.length > 0) {
      setsubCategory((prev) => ({
        ...prev,
        subcategory_alias: generateAlias(),
      }));
      setsubCategory((prev) => ({
        ...prev,
        link: `/what-we-do/${subcategory?.subcategory_alias}`,
      }));
      window.localStorage.setItem(
        subCATEGORY_FORM_STORAGE_KEY,
        JSON.stringify(subcategory)
      );
    }
  }, [subcategory?.name, subcategory?.subcategory_alias]);

  useEffect(() => {
      if (deleteSubCategoryData?.status === 200) {
        toast.success(`${JSON.stringify(deleteSubCategoryData?.data, null, 2)}`, {
          position: "top-center",
        });
        window.localStorage.removeItem(subCATEGORY_FORM_STORAGE_KEY);
        setsubCategory({
          name: "",
          subcategory_alias: "",
          description: "",
          link: "",
          image_introduction: "",
          released: false,
        });
        clearHookData()
      navigate(-1,{state: {refresh:"subcategory"}})
      }
      
    }, [deleteSubCategoryData]);

    useEffect(() => {
        if (deleteSubCategoryError) {
          toast.error(
            `${JSON.stringify(deleteSubCategoryError?.response?.data, null, 2)}`,
            { position: "top-center" }
          );
        }
      }, [deleteSubCategoryError]);

  return (
    // <Box sx={{ maxWidth: 800, mx: "auto", mt: 4, p: 3 }}></Box>
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, mt: 1,p: 2 ,width:"90%"}}>
    <Typography variant="h5" sx={{ mb: 2 }}>
            View/Edit Working Area Sub-Category
    </Typography>
      <Typography sx={{ mb: 5 }}>
        Add a new activity sub subcategory (what we do subcategory) that
        represents the areas your organization works in — such as New Born
        Health in Health, Disability Education in Education, Environment, or
        Media. These sub categories help group and organize your organization’s
        projects and initiatives for each area.
      </Typography>

      <Tabs
        value={tabPreviewCreate}
        onChange={(e, newValue) => setTabPreviewCreate(newValue)}
        centered
        sx={{ mb: 1 }}
      >
        <Tab label="View/Edit SubCategory" />
        <Tab label="Preview" />
      </Tabs>

      {tabPreviewCreate === 0 ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1, maxWidth: "80%",}}>
          {/* Name */}
          <TextField
            name="name"
            label="SubCategory Name"
            value={subcategory?.name}
            onChange={handleChange}
            fullWidth
          />

          {/* Category */}
          <TextField
            select
            name="category"
            fullWidth
            size="small"
            label="Select Category"
            value={subcategory?.category}
            onChange={handleCategoryChange}
            variant="outlined"
            helperText="Choose a category for this record"
            disabled={categoryLoading}
          >
            {categoryLoading ? (
              <MenuItem disabled>
                <CircularProgress size={20} />
                &nbsp; Loading...
              </MenuItem>
            ) : categories.length > 0 ? (
              categories?.map((cat) => (
                <MenuItem key={cat.id} value={cat.id}>
                  {cat.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No categories available</MenuItem>
            )}
          </TextField>

          {/* Alias */}
          <TextField
            name="subcategory_alias"
            label="SubCategory Alias"
            placeholder="Generated alias"
            value={subcategory?.subcategory_alias}
            onChange={handleChange}
            fullWidth
          />

          {/* Description */}
          <TextField
            name="description"
            label="Description (optional)"
            value={subcategory.description}
            onChange={handleChange}
            fullWidth
            multiline
            minRows={4}
          />

          {/* Image Upload / Link */}
          <Tabs
            value={tabIndex}
            onChange={(e, newValue) => setTabIndex(newValue)}
            centered
            sx={{ mb: 1 }}
          >
            <Tab label="Image Introduction Link" />
            <Tab label="Upload Image Introduction" />
          </Tabs>

          {tabIndex === 0 ? (
            <TextField
              name="image_introduction"
              label="Image Link"
              value={subcategory.image_introduction}
              onChange={handleChange}
              fullWidth
            />
          ) : (
            <Box
              sx={{
                border: "2px dashed #ccc",
                borderRadius: 2,
                p: 3,
                textAlign: "center",
              }}
            >
              {subcategory?.image_introduction ? (
                <img
                  src={subcategory.image_introduction}
                  alt="preview"
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    marginBottom: "8px",
                  }}
                />
              ) : (
                <UploadIcon sx={{ fontSize: 50, color: "#aaa", mb: 1 }} />
              )}

              <Button
                variant="outlined"
                onClick={() => fileInputRef.current.click()}
                disabled={FileUpload}
              >
                {subcategory.image_introduction
                  ? "Click To Change File"
                  : "Click To Upload File"}
              </Button>
              <input
                type="file"
                accept={"image/*"}
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </Box>
          )}

          {/* Submit */}
          <Button variant="contained" color="success"onClick={handleSubmit}>
           Save SubCategory
          </Button>

          {/* Submit */}
          <Button variant="contained" color="error"onClick={handleCancelAndBack}>
            Cancel
          </Button>

          <Button
                variant="contained"
                color="error"
                onClick={() => {
                setSelectedItem(`${subcategory?.name}`);
                setOpenDelete(true);
                }}
            >
                Delete SubCategory
            </Button>
            {/* <ConfirmDeleteDialog onConfirm={handleDelete} /> */}
            <ConfirmDeleteDialog
            open={openDelete}
            onClose={() => setOpenDelete(false)}
            onConfirm={handleDelete}
            loading={deleteSubCategoryLoading }
            itemName={selectedItem}
            title="Delete Category"
            message="This will permanently remove the selected category and its associated subcategories."
        />
        </Box>
      ) : (
        // <AreasOfWorkSection singleView={[subcategory]} />
        <WhatWeDo />
      )}
    </Box>
  );
}
